export default "__VITE_ASSET__ygRXTHuY__"